<template>
  <div class="indexPage">
    <job-header-simple header_title="身份认证"></job-header-simple>
    <div class="info-all" v-show="showCell">
      <div>姓&#12288&#12288名&#12288&#12288{{user.name}}</div>
      <div>身份证号&#12288&#12288{{user.idNumber}}</div>
      <div>手机号码&#12288&#12288{{user.mobile}}</div>
    </div>
    <div class="uploadSection">
      <div class="item">
        <div id="bg_front">
          <van-uploader
            v-model="frontPicArr"
            :max-count="1"
            :before-read="beforeReadFront"
          >
            <div class="bg_front"></div>
          </van-uploader>
        </div>
        <van-loading type="spinner" color="#6c7ef3" v-if="frontPicLoading" />
      </div>
      <div class="item">
        <div id="bg_back">
          <van-uploader
            v-model="backPicArr"
            :max-count="1"
            :before-read="beforeReadBack"
          >
            <div class="bg_back"></div>
          </van-uploader>
        </div>
        <van-loading type="spinner" color="#6c7ef3" v-if="backPicLoading" />
      </div>

      <van-divider>照片上传要求</van-divider>
      <div class="img">
      <img src="@/assets/error_example.png" alt />
    </div>
    </div>
    <div class="base-info">
      <van-button
          type="info"
          size="large"
          @click="handleIndentify"
          class="btn_theme"
          >认证</van-button>
    </div>
  </div>
</template>

<script>
import {
  Uploader,
  button,
  Divider,
  Dialog,
  Toast,
  Loading,
  Overlay,
  Cell
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import Exif from "exif-js";
import wx from 'weixin-js-sdk'
import { browserUA } from "@/utils/browserUA";
import {getToken} from "@/utils/auth";

export default {
  components: {
    [Uploader.name]: Uploader,
    [button.name]: button,
    [Divider.name]: Divider,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    jobHeaderSimple,
    [Cell.name]: Cell,
  },
  data() {
    return {
      id:this.$route.query.id,
      ocompanyId:this.$route.query.ocompanyId,
      frontPicArr: [],
      backPicArr: [],
      frontPic: "",
      backPic: "",
      frontPicLoading: false,
      backPicLoading: false,
      showCell: true,
      val: {
        bank_name: "",
        account: "",
      },
      user:{},
      imageOcrName: "",
      imageOcrIdNo: ""
    };
  },
  watch: {
    frontPicArr: function (now) {
      let that = this;
      let img = document.getElementById("bg_front");
      if (!now.length) {
        img.style.backgroundImage = "none";
        return;
      }
      this.imgPreview(now[0].file, function (data) {
        that.frontPic = data;
        img.style.backgroundImage = `url(${that.frontPic})`;
        that.frontPicLoading = false;

      });
    },
    backPicArr: function (now) {
      let that = this;
      let img = document.getElementById("bg_back");
      if (!now.length) {
        img.style.backgroundImage = "none";
        return;
      }
      this.imgPreview(now[0].file, function (data) {
        that.backPic = data;
        img.style.backgroundImage = `url(${that.backPic})`;
        that.backPicLoading = false;
      });
    },
  },
  created() {
    api.getActiveUserAllInfo().then((res) => {
          if (res.data.status == "200") {
            this.user = res.data.data;
            this.imageOcrName = this.user.name;
            this.imageOcrIdNo = this.user.idNumber;
          }
     })
  },
  methods: {
    authenticateIdNumber(frontPic,backPic){
        api.authenticateIdNumber({ front: frontPic, back: backPic,ocompanyId:this.ocompanyId},{ method: "post" }).then((res) => {
             Toast.clear();
             if (res.data.status == "200") { // 身份认证通过，跳转到视频认证接口
              // 判断是否小程序
              browserUA().then((browserType) => {
                if (browserType == "MINI") { // 小程序，跳转到小程序拍摄页面
                  wx.miniProgram.navigateTo({url: '/pages/individualVideo/index?ocompanyId='+this.ocompanyId+'&token='+getToken()});
                }else{
                  this.$router.push({
                    path: "/individual_video",
                    query: {
                      ocompanyId:this.ocompanyId
                    },
                  });
                }
              })
            }else{ // 认证失败，提示原因
                Dialog.alert({
                    title: "提示",
                    message: res.data.message,
                  }).then(() => {});
            }
          })
    },
    beforeReadFront(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "application/x-jpg" &&
        file.type !== "image/bmp"
      ) {
        Toast("请上传 jpg,png,jpeg,bmp 格式图片");
        return false;
      }
      this.frontPicLoading = true;
      return true;
    },
    beforeReadBack(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "application/x-jpg" &&
        file.type !== "image/bmp"
      ) {
        Toast("请上传 jpg,png,jpeg,bmp 格式图片");
        return false;
      }
      this.backPicLoading = true;
      return true;
    },
    handleIndentify() {
      this.val.bank_name = this.$route.query.bankName;
      this.val.account = this.$route.query.bankCard;
      if (this.frontPic == "" || this.backPic == "") {
        Dialog.alert({
          title: "提示",
          message: "请确认是否上传完整的证件正反面!",
        }).then(() => {});
      } else {
          Toast.loading({
            mask: true,
            message: "认证中...",
            forbidClick: true,
            duration: 0
          });
         // 校验证件信息
         api.checkImage({ front: this.frontPic, back: this.backPic},{ method: "post" }).then((res) => {
          if (res.data.status == "200") { // 校验通过，调用身份证认证接口
              this.showCell = true;
              this.authenticateIdNumber(this.frontPic,this.backPic);
          }else{ // 失败
              Toast.clear();
              if (res.data.data !== null) {
                this.showCell = true;
                this.imageOcrName = res.data.data.name;
                this.imageOcrIdNo = res.data.data.idNumber;
              }
              if(res.data.status == "50075"){ // 系统身份证姓名与号码不一致,是否确认修改
                Dialog.confirm({
                     title: "提示",
                     message: res.data.message,
                  }).then(() => { // 确认修改，修改后调用身份证认证接口
                     Toast.loading({
                        mask: true,
                        message: "认证中...",
                        forbidClick: true,
                        duration: 0
                     });
                     this.authenticateIdNumber(this.frontPic,this.backPic);
                  }).catch(() =>{

                  }) ;
              }else{ // 直接提示
                  Dialog.alert({
                     title: "提示",
                     message: res.data.message,
                 })
              }
          }
         })
      }
    },
    imgPreview(file, callback) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (this.result.length <= 100 * 1024) {
            callback(this.result);
          } else {
            img.onload = function () {
              let data = self.compress(img, Orientation);
              callback(data);
            };
          }
        };
      }
    },
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      //let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        //console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        //console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.uploadSection {
  margin: 8px 12px;
  background: #fff;
  padding: 28px 20px 10px;
  .item {
    position: relative;
    width: 250px;
    height: 122px;
    background: #ebecf4;
    border-radius: 2px;
    margin: 0 auto 18px;
    text-align: center;
    padding: 11px;

    & > div {
      height: 122px;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .van-loading {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 55px;
      background: rgba(0, 0, 0, 0.6);
    }

    /deep/ .van-uploader {
      height: 122px;
      //overflow: hidden;
    }

    /deep/ .van-uploader__preview {
      margin: 0;
    }

    /deep/ .van-uploader__preview-image {
      max-width: 250px;
      max-height: 122px;
      width: auto;
      height: auto;
      text-align: center;
    }

    /deep/ .van-image__img {
      display: inline-block;
      opacity: 0;
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }
}

.bg_front {
  display: block;
  width: 193px;
  height: 121px;
  background: url("../../assets/bg_front.png") center center no-repeat;
  background-size: contain;
}

.loading {
  z-index: 99999;
  margin-left: auto;
  margin-right: auto;
}

.bg_back {
  display: block;
  width: 193px;
  height: 121px;
  margin: 0 auto;
  background: url("../../assets/bg_back.png") center center no-repeat;
  background-size: contain;
}

.img {
  margin-top: -10px;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.base-info {
  margin: 8px 12px;
  background: #fff;
  padding: 10px 14px;
}
.info-all {
  margin: 8px 12px;
  background: #fff;
  padding: 10px 14px;
  font-size: 14px;
  
  div{
    padding: 10px 0;
    border-bottom: 1px solid #f4f7e9;
  }
}
</style>


